export const GTM_ID = import.meta.env.VITE_GTM_ID?.trim() || "";

export const isGtmEnabled = Boolean(GTM_ID);

type DataLayerValue = string | number | boolean | null | undefined;
type DataLayerEvent = Record<string, DataLayerValue>;
export type AnalyticsConsent = "granted" | "denied";

// Increase the suffix when consent text/legal basis changes
const ANALYTICS_CONSENT_KEY = "lg24_analytics_consent_v1";

declare global {
  interface Window {
    dataLayer: DataLayerEvent[];
  }
}

export function pushToDataLayer(event: DataLayerEvent) {
  if (typeof window === "undefined" || !isGtmEnabled) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event);
}

export function readAnalyticsConsent(): AnalyticsConsent | null {
  if (typeof window === "undefined") return null;
  const value = window.localStorage.getItem(ANALYTICS_CONSENT_KEY);
  if (value === "granted" || value === "denied") return value;
  return null;
}

export function saveAnalyticsConsent(consent: AnalyticsConsent) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(ANALYTICS_CONSENT_KEY, consent);
}

export function loadGtmScript(containerId: string) {
  if (typeof window === "undefined") return;
  if (!containerId) return;
  if (document.getElementById("gtm-script")) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });

  const script = document.createElement("script");
  script.id = "gtm-script";
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}`;
  document.head.appendChild(script);
}
